import React from 'react';
import { useCandidatesCache } from '../hooks/use-candidates-cache';
import SpinnerContainer from '../../../components/common/spinner-container'

export const LoadingCandidates = () => {
    const { isLoading } = useCandidatesCache();
    return !isLoading ? null : (
        <SpinnerContainer
            label='Retrieving candidates'
            size='sm'
        />
    );
};

